import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import styles from './pfFooter.module.scss';
import LogoAddress from '../logoAddress/logoAddress';
import FooterFlatNav from '../footerFlatNav/footerFlatNav';

export default function PfFooter({
  navigation = [],
  trustedBadge = {},
  config = {
    startMenusFrom: 'Right',
  },
}) {
  const [logoAddress, setLogoAddress] = useState(null);
  useEffect(() => {
    if (trustedBadge && trustedBadge.cta) {
      const newCtaProps = {
        ...trustedBadge.cta,
        heapKey: 'PF Footer cta click',
      };
      setLogoAddress({ ...trustedBadge, ...{ cta: newCtaProps } });
    } else {
      setLogoAddress(trustedBadge);
    }
  }, [trustedBadge]);
  return (
    <div className={styles.productFooter}>
      <div className={styles.container}>
        <div className={`${styles.section} ${styles.borderBottom}`}>
          <LogoAddress {...logoAddress} className={styles.productFooterItem} />
          <div className={styles.right}>
            <FooterFlatNav
              navData={navigation}
              config={config}
              className={styles.productFooterItem}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

PfFooter.propTypes = {
  navigation: PropTypes.array,
  trustedBadge: PropTypes.object,
  config: PropTypes.shape({
    startMenusFrom: PropTypes.oneOf(['Left', 'Right']),
  }),
};
